import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../constants/actions';
import { LEGACY_APP as legacyAppUrl } from '../../constants/urls';
import boosterImg from './booster-chrome.png';
import './UnsupportedBrowser.css';

const mapStateToProps = state => ({
	browserInfo: state.app.browserInfo,
	legacyBrowser: state.app.legacyBrowser,
	osInfo: state.app.osInfo,
	supportedPlatform: state.app.supportedPlatform
});

const mapDispatchToProps = dispatch => ({
	onClick: () => dispatch({ type: actions.APP_OVERRIDE_SUPPORTED_BROWSER })
});

class UnsupportedBrowser extends Component {
	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	componentDidMount() {
		// If we don't support the platform, automatically kick them over to the legacy app
		if (!this.props.supportedPlatform) {
			window.location.href = legacyAppUrl;
		}
		window.document.title = 'Unsupported Browser | Imagine Learning';
	}

	handleClick(e) {
		e.preventDefault();
		this.props.onClick();
	}

	render() {
		const browserInfo = this.props.browserInfo;
		const osInfo = this.props.osInfo;
		const override = this.props.legacyBrowser
			? <div>
					<p>
						We're adding support for more browsers in future releases. If you're unable to use Chrome, try using the
						Imagine Learning legacy app (<a href={legacyAppUrl}>{legacyAppUrl}</a>) in your current browser.
					</p>
					<p>
						<a href={legacyAppUrl} className="button secondary small">
							Go to legacy app
						</a>
					</p>
				</div>
			: <div>
					<p>
						If you believe you are seeing this message in error you may continue to the application. However, we cannot
						guarantee the application will work as expected.
					</p>
					<p>
						<a onClick={this.handleClick}>Continue to Imagine Language &amp; Literacy (not recommended)</a>
					</p>
				</div>;
		return (
			<div className="UnsupportedBrowser row medium-10 small-12 columns content">
				<div className="row">
					<div className="medium-centered medium-10 columns">
						<div className="row">
							<div className="large-6 small-12 columns">
								<div className="card">
									<div className="card-section">
										<h1>Unsupported Browser</h1>
										<p>
											Unfortunately, Imagine Language &amp; Literacy may not work properly in your browser. We encourage
											you to install the latest version of{' '}
											<a href="https://www.google.com/chrome/browser" rel="noopener noreferrer" target="_blank">
												Chrome
											</a>. For more information please review our{' '}
											<a
												href="https://support.imaginelearning.com/imagine-language-literacy/system-requirements"
												rel="noopener noreferrer"
												target="_blank"
											>
												system requirements
											</a>.
										</p>
										<p>
											<a
												className="button primary large"
												href="https://www.google.com/chrome/browser"
												rel="noopener noreferrer"
												target="_blank"
											>
												Get Chrome
											</a>
										</p>
										<hr />
										<section className="override">
											<p>
												We have detected you are using {browserInfo} on {osInfo}.
											</p>
											{override}
										</section>
									</div>
								</div>
							</div>
							<div className="large-6 small-12 columns">
								<img src={boosterImg} alt="Booster" />
							</div>
						</div>
					</div>
				</div>
				<div className="footer" />
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UnsupportedBrowser);



// WEBPACK FOOTER //
// ./src/components/UnsupportedBrowser/UnsupportedBrowser.js